import {
    CheckOutlineIcon, CommentOutlineIcon,
    CompletePersonChip, DeniedOutlineIcon,
    PersonChip
} from "../../../../components/buttons/IconButtons";
import {CustomLevelCardStyle} from "../../../../components/Styles";
import CustomMediumChip from "../../../../components/CustomMediumChip";
import {POSITION_MODEL} from "../../../../Helpers/PositionModel";
import CustomChip from "../../../../components/CustomChip";
import {statusBorderColor, statusColor, statusFontColor} from "../../../../enums/statusColorEnum";
import {status, STATUS_MODEL} from "../../../../enums/statusEnum";
import ButtonAction from "../../../../components/buttons/ButtonAction";
import React from "react";
import {Box} from "@mui/material";
import {canRequestChanges} from "../Model/Model";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 * LevelCard Component
 *
 * This component displays a visual representation of a specific approval level within an approval tracker flow.
 * It renders the level number, approval condition, approvers with their statuses, and action buttons
 * (Approve, Deny, Comment) depending on the approval state and user permissions.
 *
 * @component
 *
 * @param {Object} props
 * @param {Object} props.item - The approval level object, including approvers and level metadata.
 * @param {Function} props.t - Translation function (i18n).
 * @param {boolean} props.disabled - Whether the card is disabled (read-only).
 * @param {Function} props.setRow - Callback to set the current approval level row.
 * @param {Function} props.setShowApprove - Callback to trigger approval modal visibility.
 * @param {Function} props.setShowDenied - Callback to trigger denial modal visibility.
 * @param {Function} props.setShowIssueComment - Callback to trigger comment modal visibility.
 * @param {number} props.responded - Number of users who have responded.
 * @param {number} props.pending - Number of pending responses.
 * @param {number|string} props.row - The current row identifier.
 * @param {Object} props.user - Authenticated user information.
 * @param {boolean} props.details - Whether the component is being rendered in detail view (read-only).
 *
 * @returns {JSX.Element} Rendered LevelCard component.
 */
const LevelCard = ({item, t, disabled,setRow ,setShowApprove,setShowDenied,setShowIssueComment,responded,
                             pending,row,user,details,module}) => {

    let styles = CustomLevelCardStyle(item?.levelStatusId, disabled);

    return (
        <>
            <div className={"d-flex justify-content-start mt-5"}>
                <div className={"d-flex flex-column align-items-center"}>
                    <div style={styles.circle} className={"mb-32px mr-32px"}/>
                    <div style={styles.line} className={"mr-32px"}/>
                </div>
                <div style={styles.container}>
                    <div style={styles.levelCard}>
                        <div className={"d-flex justify-content-between align-items-center"}>
                            <p style={styles.level}>{t('level')} {item?.levelNumber}</p>
                            <div className={"d-flex gap-2 align-items-center"}>
                                <CompletePersonChip style={styles.icon}/>
                                <p style={styles.p}> {item?.approvers?.length}</p>
                            </div>
                        </div>
                        <div className={"d-flex justify-content-between align-items-center"}>
                            <p  style={styles.p}>{t(item?.approvalCondition)}</p>
                            <p style={styles.p} className="d-flex align-items-center">
                                {responded} {t("responded")} &nbsp;| &nbsp;
                                <span className={`d-flex align-items-center ${!disabled && pending >= 1
                                    ? "font-color-error-700"
                                    : ""}`}
                                      style={styles.p}>{pending} {t("pending")}</span>
                            </p>
                        </div>
                    </div>
                    <div className={"d-flex flex-column w-100 gap-3 p-16px"}>
                        {
                            item?.approvers?.map((data) => {
                                return (
                                    <CustomMediumChip
                                        Icon={PersonChip}
                                        showAvatar={true}
                                        completeWidth={true}
                                        key={data?.userId}
                                        title={data?.userName}
                                        iconPosition={POSITION_MODEL.LEFT}
                                        disabled={disabled}
                                        rightContent={
                                            <div className={"d-flex-end gap-2"}>
                                                <CustomChip
                                                    variant={'large'}
                                                    background={statusColor[!disabled ? data?.statusId : 1000]}
                                                    fontColor={statusFontColor[!disabled ? data?.statusId : 1000]}
                                                    borderColor={statusBorderColor[!disabled ? data?.statusId : 1000]}
                                                    legend={t(status[data?.statusId]) || '-'}
                                                />
                                                {!details &&
                                                    item.levelCompleted !== true &&
                                                    (item.statusId !== STATUS_MODEL.APPROVED &&
                                                        item.statusId !== STATUS_MODEL.DENIED &&
                                                        data.statusId !== STATUS_MODEL.APPROVED &&
                                                        data.statusId !== STATUS_MODEL.DENIED &&
                                                        user?.data?.id === data?.userId &&
                                                        !disabled) &&
                                                    (
                                                        <>
                                                            <ButtonAction
                                                                Icon={CheckOutlineIcon}
                                                                id='btn_lc_approved_modal'
                                                                className={'btn-icon-svg-chip-button btn-outlined-success-600 w-40px h-40px minw-40px p-0'}
                                                                iconProps={'icon'}
                                                                iconClass={"mr-0"}
                                                                disabled={false}
                                                                onClick={() => {
                                                                    setRow(row)
                                                                    setShowApprove(true);
                                                                }}
                                                            />
                                                            <ButtonAction
                                                                Icon={DeniedOutlineIcon}
                                                                id='btn_lc_denied_modal'
                                                                className={'btn-icon-svg-chip-button btn-outlined-error-600 w-40px h-40px minw-40px p-0'}
                                                                iconProps={'icon'}
                                                                iconClass={"mr-0"}
                                                                disabled={false}
                                                                onClick={() => {
                                                                    setRow(row)
                                                                    setShowDenied(true);
                                                                }}
                                                            />
                                                            {
                                                                canRequestChanges(module) &&
                                                                <ButtonAction
                                                                    Icon={CommentOutlineIcon}
                                                                    id='btn_lc_comment_modal'
                                                                    className={'btn-icon-svg-chip-button btn-outlined-warning-600 w-40px h-40px minw-40px p-0'}
                                                                    iconProps={'icon'}
                                                                    iconClass={"mr-0"}
                                                                    disabled={false}
                                                                    onClick={() => {
                                                                        setRow(row)
                                                                        setShowIssueComment(true);
                                                                    }}
                                                                />

                                                            }

                                                        </>
                                                    )
                                                }
                                            </div>
                                        }
                                    >
                                        {
                                            data?.reason &&
                                            <Box className='col-12 mt-2'>
                                                <Box style={styles.boxComentary}>
                                                   <p>{data?.reason}</p>
                                                </Box>

                                            </Box>
                                        }

                                    </CustomMediumChip>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        </>
    )

}

export default LevelCard
